export const testimonials = [
  {
    id: 1,
    name: '漫画迷小樱',
    username: '@sakura_comic',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20simple%20pastel%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '韩漫网真的太棒了！画质高清，更新速度快，下拉式阅读体验超级流畅。现在已经是我每天必刷的漫画网站了，强烈推荐给所有韩漫爱好者！',
    rating: 5,
  },
  {
    id: 2,
    name: '追更狂人阿豪',
    username: '@haomanga',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20dark%20hair%20and%20glasses%2C%20simple%20dark%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '收藏了十几部韩漫在这里追更，每天都有更新提醒，再也不用担心错过最新章节了。分类也很清晰，找漫画特别方便！',
    rating: 5,
  },
  {
    id: 3,
    name: '深夜读者小茹',
    username: '@nightreader',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20long%20black%20hair%20and%20sleepy%20eyes%2C%20simple%20warm%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '下拉式阅读不要太爽！躺在床上单手就能翻页，画质也很清晰。唯一缺点就是好看的太多了，根本停不下来，天天熬夜看漫画。',
    rating: 5,
  },
  {
    id: 4,
    name: '资深漫画控',
    username: '@comicmaster',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20mature%20man%20avatar%20with%20short%20hair%20and%20confident%20smile%2C%20simple%20gradient%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '看了十年韩漫，韩漫网是我用过体验最好的平台。完全免费没有广告弹窗，资源齐全，连很多冷门好作品都能找到，真爱粉无疑！',
    rating: 5,
  },
  {
    id: 5,
    name: '甜甜恋爱脑',
    username: '@sweetlove',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20blonde%20twin%20tails%20and%20heart%20eyes%2C%20simple%20pink%20background%2C%20clean%20kawaii%20illustration%20style&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '恋爱韩漫爱好者的天堂！《女神降临》《公爵的契约未婚妻》都是我的最爱，每天追更简直不要太幸福。感谢韩漫网陪伴我的每一天！',
    rating: 5,
  },
  {
    id: 6,
    name: '冷静分析师',
    username: '@analyst_k',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20serious%20man%20avatar%20with%20short%20brown%20hair%20and%20analytical%20expression%2C%20simple%20blue%20gray%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-06&orientation=squarish',
    content: '从技术角度说，网站的加载速度和阅读体验确实一流。下拉式设计响应灵敏，移动端适配也很好。作为一个挑剔的老用户，找不出什么毛病。',
    rating: 4,
  },
];